import { ReactNode } from "react";
import styles from "./ResponsiveAssetListAuto.module.scss";
import { clsx } from "clsx";
import useIsMediaLessThan from "../../core-ui/useIsMediaLessThan.ts";

interface AssetGridProps {
  children: ReactNode;
}

/**
 * Vertical for large screens, single-column horizontal for small screens
 */
export default function ResponsiveAssetListAuto({ children }: AssetGridProps) {
  const isHorizontal = useIsMediaLessThan(768);
  return (
    <ul
      className={
        isHorizontal
          ? clsx("vst-book-card-group-horizontal", styles.defaultHorizontalList)
          : clsx("vst-book-card-group-vertical", styles.defaultVerticalGrid)
      }
    >
      {children}
    </ul>
  );
}
